export const debounce = <F extends (...args: any[]) => any>(
    func: F,
    delay: number = 500
): ((...args: Parameters<F>) => ReturnType<F>) => {
    let timeout: number;

    const debounced = (...args: Parameters<F>) => {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = window.setTimeout(() => func.apply(self, args), delay);
    };

    return debounced as (...args: Parameters<F>) => ReturnType<F>;
};
